import { z } from 'zod'

export const FlowActionsChildEditionDataSchema = z.object({
  canShowVolunteerCooperationSection: z.boolean(),
  canToggleVolunteerCooperation: z.boolean(),
  canViewGiftGiverModuleLink: z.boolean(),
  canViewChildChoicePathLink: z.boolean()
})

export const FlowActionsChildEditionResponseSchema = z.object({
  data: FlowActionsChildEditionDataSchema
})

export const UpdateFlowActionsChildEditionResponseSchema = z.object({
  data: z.object({
    flow_actions: FlowActionsChildEditionDataSchema
  })
})

export const FlowActionsPaymentDataSchema = z.object({
  canResendP24InstallmentNotification: z.boolean()
})

export const FlowActionsPaymentResponseSchema = z.object({
  data: FlowActionsPaymentDataSchema
})

export const UpdateFlowActionsPaymentResponseSchema = z.object({
  data: z.object({
    flow_actions: FlowActionsPaymentDataSchema
  })
})
